(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.reevys-cart-move-list');
    if (!button) return;

    const key = 'reevys:wishlist:v1';
    let items = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(parsed) ? parsed : [];
    } catch (error) {}

    const id = button.dataset.productId;
    if (!items.some((item) => String(item.id) === String(id))) {
      items.unshift({
        id,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage || '',
        addedAt: Date.now()
      });
      try { localStorage.setItem(key, JSON.stringify(items)); } catch (error) {}
      window.dispatchEvent(new CustomEvent('reevys:wishlist:change', { detail: { count: items.length, items } }));
    }

    button.closest('.cart-items__table-row')?.querySelector('.cart-items__remove')?.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reevys-daily-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reevys-daily-countdown')) {
    class ReevysDailyCountdown extends HTMLElement {
      connectedCallback() {
        this.digits = this.querySelector('[role="timer"]');
        if (!this.digits) return;
        this.sync();
        clearInterval(this.interval);
        this.interval = setInterval(this.sync, 1000);
        document.addEventListener('visibilitychange', this.sync);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.sync);
      }

      sync = () => {
        if (!this.digits || document.hidden) return;
        const now = new Date();
        let deadline = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59);
        if (deadline <= now.getTime()) deadline += 86400000;
        const seconds = Math.ceil((deadline - now.getTime()) / 1000);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainder = seconds % 60;
        const values = [hours, minutes, remainder].map(value => String(value).padStart(2, '0'));
        this.digits.textContent = `${values[0]}${this.dataset.hoursLabel} ${values[1]}${this.dataset.minutesLabel} ${values[2]}${this.dataset.secondsLabel}`;
        this.digits.hidden = false;
      };
    }
    customElements.define('reevys-daily-countdown', ReevysDailyCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
